// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-entity-buttons {
  container-type: inline-size;
  width: 100%;
}

/* Stacked by default; side by side once the container is wide enough. */
.new-entity-buttons__row {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

@container (min-width: 300px) {
  .new-entity-buttons__row {
    flex-direction: row;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/AddNewEntity/NewEntityButtons.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".new-entity-buttons {\n  container-type: inline-size;\n  width: 100%;\n}\n\n/* Stacked by default; side by side once the container is wide enough. */\n.new-entity-buttons__row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n@container (min-width: 300px) {\n  .new-entity-buttons__row {\n    flex-direction: row;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
